import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useDebriefStatus } from 'ff/debrief/hooks';

const ReanalysisInProgressIndicator = () => {
    const { isReanalyzing } = useDebriefStatus();
    if (!isReanalyzing) {
        return null;
    }

    return <CircularProgress size={16} />;
};

export default ReanalysisInProgressIndicator;
